import request from '../../shared/request';

export interface LoadingPhrase {
  id: number;
  text: string;
  course_tag: string | null;
  is_active: boolean;
}

interface GetRandomLoadingPhrasesParams {
  courseTag?: string | null;
  limit?: number;
}

/**
 * Busca frases aleatórias ativas para as telas de loading.
 *
 * - Quando `courseTag` é informado e o curso tem frases, retorna frases do curso.
 * - Caso contrário, o backend faz fallback para frases globais.
 * - O pool é cacheado no backend por 300s.
 */
export async function getRandomLoadingPhrases({
  courseTag,
  limit = 10,
}: GetRandomLoadingPhrasesParams = {}): Promise<LoadingPhrase[]> {
  const qsParams: Record<string, string | number> = { limit };
  if (courseTag) qsParams.course_tag = courseTag;

  const response = await request('/v1/services/loading-phrases/random', {
    method: 'GET',
    qsParams,
  });

  return Array.isArray(response?.data) ? response.data : [];
}
